export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS/UPDATE';

export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_DROPDOWNS = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS/UPDATE_DROPDOWNS';
export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_SEARCH_FILTER_OPTION = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_SEARCH_FILTER_OPTION';

export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ZOOM_RESTRICT_LEVELS = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS/SET_ZOOM_RESTRICT_LEVELS';
export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ALLOWED_EXPORT_DATA_TOOLS = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS/SET_ALLOWED_EXPORT_DATA_TOOLS';
export const MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_THEME = 'MAP_SETTINGS_PUBLIC_MAP_SETTINGS/MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_THEME';
